import React from 'react'

const index = () => {
  return (
    <div>
      <h1>ini kwitiau</h1>
    </div>
  )
}

export default index
